import { render, staticRenderFns } from "./uokoWithdrawalManage.vue?vue&type=template&id=2d1e3b14&scoped=true"
import script from "./uokoWithdrawalManage.vue?vue&type=script&lang=js"
export * from "./uokoWithdrawalManage.vue?vue&type=script&lang=js"
import style0 from "./uokoWithdrawalManage.vue?vue&type=style&index=0&id=2d1e3b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e3b14",
  null
  
)

export default component.exports